const ArrowLeftIcon = ({
  fill = "none",
  width = "24",
  height = "24",
  strokeWidth = "1.8",
}) => {
  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.57 5.93018L3.5 12.0002L9.57 18.0702"
        stroke={fill}
        stroke-width={strokeWidth}
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.4999 12H3.66992"
        stroke={fill}
        stroke-width={strokeWidth}
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default ArrowLeftIcon;
